import { Grid, Card, CardContent, Typography } from '@mui/material';
import { summaryChartsProps } from '../../domain/charts/summary-charts-props';
import { SplineChartWithHeader } from '@features/campaigns/components/Summary/SplineChartWithHeader';

type SalesMetricsProps = {
  allReports: Parameters<typeof summaryChartsProps>[0]['reports'];
  enableSalesRate: boolean;
};

export const SalesMetrics = ({
  allReports,
  enableSalesRate,
}: SalesMetricsProps) => {
  const chartsProps = summaryChartsProps({
    reports: allReports,
    excludedCharts: enableSalesRate ? [] : (['totalSalesRate'] as const),
  });

  return (
    <Grid container spacing={3}>
      {chartsProps.map(chartProps => (
        <Grid
          key={chartProps.title}
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom></Typography>
              <SplineChartWithHeader {...chartProps} />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
